import { Box } from '@startuptools/ui/Box';
import { Card } from '@startuptools/ui/Card';
import { IconButton } from '@startuptools/ui/IconButton';
import { Sheet } from '@startuptools/ui/Sheet';
import { Stack } from '@startuptools/ui/Stack';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { MeetingUploads } from './MeetingUploads';
import { type GqlBolagoFile, type GqlMeeting } from '../../../../graphql/base-types.graphql';
import { MeetingSummonsDocument } from './MeetingSummons';
import { type DisplayDocument } from '@startuptools/business-ui/document/Document';

export const MeetingSummonsWithUploads = ({
  meeting,
  refetch,
}: {
  meeting: Pick<GqlMeeting, 'id' | 'number' | 'startTime' | 'kind'> & {
    latestSummonsDocument?: Pick<GqlBolagoFile, 'id'> | null;
    meetingAppendices: DisplayDocument[];
  };
  refetch: () => void;
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Card>
      <Stack direction="row" gap={1} justifyItems="center">
        <Box>
          <IconButton variant="outlined" onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        <MeetingSummonsDocument meeting={meeting} refetch={refetch} />
      </Stack>
      {expanded && (
        <Sheet variant="soft" sx={{ padding: 2 }}>
          <MeetingUploads meeting={meeting} isSummons refetch={refetch} />
        </Sheet>
      )}
    </Card>
  );
};
